import React, { useEffect } from "react";

// Lightweight document head manager (no react-helmet needed).
// Updates title, description, canonical, OG title/description on mount/update.
export default function PageMeta({
    title,
    description,
    canonicalPath,
    noindex = false,
}) {
    useEffect(() => {
        if (title) document.title = title;

        const setMeta = (selector, attr, value) => {
            const el = document.querySelector(selector);
            if (el && value) el.setAttribute(attr, value);
        };

        if (description) {
            setMeta('meta[name="description"]', "content", description);
            setMeta(
                'meta[property="og:description"]',
                "content",
                description,
            );
            setMeta(
                'meta[name="twitter:description"]',
                "content",
                description,
            );
        }
        if (title) {
            setMeta('meta[property="og:title"]', "content", title);
            setMeta('meta[name="twitter:title"]', "content", title);
        }
        if (canonicalPath) {
            const origin =
                typeof window !== "undefined" ? window.location.origin : "";
            const full = origin + canonicalPath;
            setMeta('link[rel="canonical"]', "href", full);
            setMeta('meta[property="og:url"]', "content", full);
        }

        // robots
        let robots = document.querySelector('meta[name="robots"]');
        if (!robots) {
            robots = document.createElement("meta");
            robots.setAttribute("name", "robots");
            document.head.appendChild(robots);
        }
        robots.setAttribute(
            "content",
            noindex
                ? "noindex, nofollow"
                : "index, follow, max-image-preview:large",
        );
    }, [title, description, canonicalPath, noindex]);

    return null;
}
